var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_vm._l((_vm.histories),function(h){return [_c('history-entry',{key:h.id,attrs:{"history":h,"showPhoto":true}}),_c('v-divider',{key:h.id+'d',attrs:{"inset":""}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }